import { render, staticRenderFns } from "./detailBox.vue?vue&type=template&id=e0934a80&scoped=true"
import script from "./detailBox.vue?vue&type=script&lang=js"
export * from "./detailBox.vue?vue&type=script&lang=js"
import style0 from "./detailBox.vue?vue&type=style&index=0&id=e0934a80&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0934a80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0934a80')) {
      api.createRecord('e0934a80', component.options)
    } else {
      api.reload('e0934a80', component.options)
    }
    module.hot.accept("./detailBox.vue?vue&type=template&id=e0934a80&scoped=true", function () {
      api.rerender('e0934a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/expressAndlargOrder/component/detailBox.vue"
export default component.exports